import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {SpacierArcadeGameConfig} from "../SpacierArcadeGameConfig";
import {TimelineLite, TweenLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {SAReelView} from "./SAReelView";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {SpacierArcadeModeData} from "../server/data/SpacierArcadeModeData";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {SAReelEvent} from "./SAReelController";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {isNumber} from "util";

export class SAReelAreaView extends ReelAreaView {
    private _timeLine: TimelineLite;
    private _attentionLayer:PIXI.Container;
    private _specialSymLayer:PIXI.Container;
    private _saReelAreaMask:PIXI.Graphics | PIXI.Sprite;
    private _attentionAreaMask:PIXI.Graphics | PIXI.Sprite;
    private _isSpinning:boolean;
    private _leftContainer:PIXI.Container;
    private _middleContainer:PIXI.Container;
    private _rightContainer:PIXI.Container;
    private _dimmer:PIXI.Graphics;
    private _reelDimmer:PIXI.Graphics;


    constructor(resourcesGroup?:ResourcesGroupName) {
        super(resourcesGroup);
        this._isSpinning = false;
        this._attentionLayer = new PIXI.Container();
        this._attentionLayer.position.set(0, GameConfig.instance.REEL_AREA_POS_Y);
        this._dimmer = new PIXI.Graphics();
        this._reelDimmer = new PIXI.Graphics();
        this._reelDimmer.alpha = 0;
        this._dimmer.alpha = 0;
        this._leftContainer = new PIXI.Container();
        this._rightContainer = new PIXI.Container();
        this._middleContainer = new PIXI.Container();
        this._middleContainer.addChild(new PIXI.Container());
        this._middleContainer.addChild(new PIXI.Container());
        this.addChild(this._leftContainer);
        this.addChild(this._rightContainer);
        this.addChild(this._middleContainer);

        StageManager.getLayer(SpacierArcadeGameConfig.instance.LAYERS.SPIN_SPINE.name).addChild(this._dimmer);
        StageManager.getLayer(SpacierArcadeGameConfig.instance.LAYERS.SPIN_SPINE.name).addChild(this._reelDimmer);
        StageManager.getLayer(SpacierArcadeGameConfig.instance.LAYERS.SYMBOLS_ATTENTION.name).addChild(this._attentionLayer);
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, SAReelEvent.SHOW_FREE_SPIN_REEL_VIEW, () => this.updateReelPositions(true));
        EventHandler.addEventListener(this, SAReelEvent.SHOW_BASE_GAME_REEL_VIEW, () => this.updateReelPositions());
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, () => this.updateReelPositions());
        EventHandler.addEventListener(this, SpinEvent.STOPPED, () => this.UpdateReelAreaMask(true));
        EventHandler.addEventListener(this, SAReelEvent.UPDATE_NEAR_REEL_VIEW, () => this.updateReelAreaNearWin());
        EventHandler.addEventListener(this, SAReelEvent.RESET_NEAR_REEL_VIEW, () => this.resetReelAreaNearWin());
    }

    private updateReelAreaNearWin():void{
        let nearReelAim: TimelineLite = new TimelineLite();

        nearReelAim.add([
            () => {this._dimmer.alpha = 1;},
            () => {this._reelDimmer.alpha = 1;},
            TweenLite.to(this._middleContainer.scale, 0.5, {x: 1.15, y: 1.15}),
            TweenLite.to(this._middleContainer.position, 0.5, {x: -76, y: -30}),
            TweenLite.to(this._attentionLayer.scale, 0.5, {x: 1.15, y: 1.15}),
            TweenLite.to(this._attentionLayer.position, 0.5, {x: -76, y: 60}),
        ]);

    }

    protected onResize(resizeData: IResizeData):void{
        super.onResize(resizeData);
        let screenWidth = Math.ceil(resizeData.width / this._layer.scale.x);
        let screenHeight = Math.ceil(resizeData.height / this._layer.scale.y);
        let leftOffset = Math.floor(-this._layer.x / this._layer.scale.x);
        let topOffset = Math.floor(-this._layer.y / this._layer.scale.y);

        let multiRatio:number = resizeData.orientation === Orientation.PORTRAIT? 0.975 : 0.55;
        topOffset = resizeData.orientation === Orientation.PORTRAIT? 90 : 90;
        screenHeight = resizeData.orientation === Orientation.PORTRAIT? GameConfig.instance.REEL_AREA_HEIGHT : GameConfig.instance.REEL_AREA_HEIGHT + 100;
        this._dimmer.clear();
        this._dimmer.beginFill(0x000000, 0.7);
        this._dimmer.drawRect(-288, topOffset, screenWidth * multiRatio, screenHeight);
        this._dimmer.endFill();
        this._reelDimmer.clear();
        this._reelDimmer.beginFill(0x000000, 0.7);
        this._reelDimmer.drawRect(screenWidth * multiRatio - 115, topOffset, screenWidth, screenHeight);
        this._reelDimmer.endFill();
    }

    private resetReelAreaNearWin():void{
        let nearReelAim: TimelineLite = new TimelineLite();
        nearReelAim.add([
            () => {this._dimmer.alpha = 0;},
            () => {this._reelDimmer.alpha = 0;},
            TweenLite.to(this._middleContainer.scale, 0.3, {x: 1, y: 1}),
            TweenLite.to(this._middleContainer.position, 0.3, {x: 0, y: 0}),
            TweenLite.to(this._attentionLayer.scale, 0.3, {x: 1, y: 1}),
            TweenLite.to(this._attentionLayer.position, 0.3, {x: 0, y: 90}),
        ]);
    }

    private updateReelPositions(enteringFreeSpin:boolean = false):void{
        this._reelViews.forEach((reelView:PIXI.Container, reelId:number) => {
            this.updateReelViewPosition(reelView, reelId, enteringFreeSpin);
        });
        this.UpdateReelAreaMask();
    }



    protected UpdateReelAreaMask(spinStopped:boolean = false):void {
        if(GameConfig.instance.REEL_AREA_MASK === false) {
            return;
        }
        const rect:PIXI.Rectangle = new PIXI.Rectangle(GameConfig.instance.REEL_AREA_POS_X - 1000, GameConfig.instance.REEL_AREA_POS_Y ,
                GameConfig.instance.REEL_AREA_WIDTH + 2000, GameConfig.instance.REEL_AREA_HEIGHT);

        // const otherRect:PIXI.Rectangle = new PIXI.Rectangle(GameConfig.instance.REEL_AREA_POS_X - 50, GameConfig.instance.REEL_AREA_POS_Y - (this._isSpinning? 20 : 50),
        //     GameConfig.instance.REEL_AREA_WIDTH + 100, GameConfig.instance.REEL_AREA_HEIGHT + (this._isSpinning? 40 : 100));


        const maskShape = new PIXI.Graphics();
        maskShape.beginFill(0xFFFFFF, 1);
        maskShape.drawRect(rect.x - GameConfig.instance.REEL_AREA_POS_X, rect.y - GameConfig.instance.REEL_AREA_POS_Y, rect.width, rect.height);
        maskShape.endFill();

        const otherMaskShape = new PIXI.Graphics();
        otherMaskShape.beginFill(0xFFFFFF, 1);
        otherMaskShape.drawRect(rect.x - GameConfig.instance.REEL_AREA_POS_X, rect.y - GameConfig.instance.REEL_AREA_POS_Y, rect.width, rect.height);
        otherMaskShape.endFill();

        if(this._saReelAreaMask != null) {
            this.removeChild(this._saReelAreaMask);
        }

        if(this._attentionAreaMask != null){
            this._attentionLayer.removeChild(this._attentionAreaMask);
        }
        this._attentionAreaMask = otherMaskShape;
        this._attentionLayer.addChild(this._attentionAreaMask);
        this._attentionLayer.mask = this._attentionAreaMask;

        this._saReelAreaMask = maskShape;

        this.addChild(this._saReelAreaMask);
        this.mask = this._saReelAreaMask;
    }

    public addReelView(reel:ReelController):void {
        this._reelViews[reel.reelId] = <SAReelView>reel.view;
        this.updateReelViewPosition(reel.view, reel.reelId);
        switch (reel.reelId) {
            case 0:
                this._leftContainer.addChild((<SAReelView>reel.view).bottomLayer);
                break;
            case 1:
            case 2:
            case 3:
                (<PIXI.Container>this._middleContainer.children[0]).addChild((<SAReelView>reel.view).bottomLayer);
                (<PIXI.Container>this._middleContainer.children[1]).addChild((<SAReelView>reel.view).specialSymLayer);
                break;
            case 4:
                this._rightContainer.addChild((<SAReelView>reel.view).bottomLayer);
                break;
        }
        this._attentionLayer.addChild((<SAReelView>reel.view).attentionLayer);
    }

    protected updateReelViewPosition(reelView:PIXI.Container, reelId:number, enteringFreeSpin:boolean = false):void {
        const position =  GameConfig.instance.REEL_DISPLAY_POSITIONS[reelId];
        let posY:number = position[1];
        if(SpacierArcadeGameConfig.instance.reelViewExpanded !== undefined){
            if(SpacierArcadeGameConfig.instance.reelViewExpanded){
                posY = 0;
            }
        }
        else if(SpacierArcadeModeData.instance.isFreespin){
            posY = 0;
        }
        (<SAReelView>reelView).attentionLayer.position.set(position[0], posY);
        (<SAReelView>reelView).specialSymLayer.position.set(position[0], posY);
        (<SAReelView>reelView).bottomLayer.position.set(position[0], posY);
    }
}